import PropTypes from "prop-types";
import InspectionsFormV3 from "modules/inspections/components/InspectionForm";
import inspectionAPI from "modules/inspections/api";
import { useAuth0 } from "@auth0/auth0-react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useSoftUIController } from "hooks/context";
import moment from "moment";

function CreateInspection({ selected_user, all_devices, maintenance_tags = [], selected_device = null, all_inspections = [] }) {
    const queryClient = useQueryClient();
    inspectionAPI.loadToken(useAuth0());

    const [controller] = useSoftUIController();
    const { selectedOrg } = controller;

    const { mutateAsync } = useMutation({
        mutationFn: ([metadata, values, onProgressUpdate]) => {
            const targetUuid = metadata.devices?.[0]?.uuid || selected_device?.uuid;
            const targetRecordedAt = metadata?.recordedAt ? moment(metadata.recordedAt).unix() : moment().unix();

            const hasUnresolvedThread = all_inspections.filter(i => i.status == "unresolved").find((inspection) => moment(inspection.recordedAt).unix() < targetRecordedAt && inspection.devices?.[0]?.uuid == targetUuid);            
            if (hasUnresolvedThread) {
                values.append('to_update', JSON.stringify({
                    status: metadata.status
                }));
                values.append('metadata', JSON.stringify({
                    inspection_record_id: hasUnresolvedThread?.ascendant_tree?.[0]?.record?._id || hasUnresolvedThread._id,
                    assignment_record_id: hasUnresolvedThread._id,
                    organisation_id: hasUnresolvedThread.organisation_id,
                }));
                values.append('contents', JSON.stringify(metadata));

                return inspectionAPI.addNewRectification(values, onProgressUpdate);
            }

            values.append('metadata', JSON.stringify(metadata));
            return inspectionAPI.addNewInspection(values, onProgressUpdate);
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['getAllInspectionsForUser', selected_user.user, selectedOrg] });
        }
    });

    return <InspectionsFormV3 {...{ selected_user, all_devices, maintenance_tags, selected_device }} onSubmit={mutateAsync} />
}

CreateInspection.propTypes = {
    selected_user: PropTypes.object.isRequired,
    all_devices: PropTypes.array.isRequired,
    maintenance_tags: PropTypes.array,
    selected_device: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
    all_inspections: PropTypes.array
};

export default CreateInspection;